export const envPrefix = (separator, prefix = "") => {
    const CONFIG_ENV = process.env.CONFIG_ENV;
    if (!CONFIG_ENV)
        return prefix === "" ? "" : `${prefix}${separator}`;
    const validEnvs = ["dev", "preview"];
    if (validEnvs.includes(CONFIG_ENV)) {
        return `${CONFIG_ENV}${separator}`;
    }
    return prefix === "" ? "" : `${prefix}${separator}`;
};
